'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosArrowThinLeft = function IoIosArrowThinLeft(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm14.8 27.3c-0.1 0.2-0.3 0.2-0.4 0.2s-0.3 0-0.5-0.2c0 0-6.2-6.8-6.2-6.8s-0.2-0.3-0.2-0.5 0.1-0.4 0.2-0.5 6.2-6.8 6.2-6.8c0.2-0.3 0.7-0.3 0.9 0s0.3 0.7 0 0.9l-5.2 5.8h22.3c0.3 0 0.6 0.3 0.6 0.6s-0.3 0.6-0.6 0.6h-22.3l5.2 5.8c0.3 0.2 0.3 0.7 0 0.9z' })
        )
    );
};

exports.default = IoIosArrowThinLeft;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-arrow-thin-left.js
// module id = 2551
// module chunks = 168707334958949